// extracted by css-extract-rspack-plugin
export default {"Root":"AggregationItem-module__Root___cTAIi","AggregationName":"AggregationItem-module__AggregationName___MJUEj","RemoveIcon":"AggregationItem-module__RemoveIcon___y_a2S"};